export const ACCOUNT_NUMBER_DEFAULT_VALUE = { customerName: '', customerReference: '' };
